import React, { useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import fnc from '../mymod/commFunction';
import { useDispatch } from 'react-redux';
import { setIsAdmin, setIsLoggedIn, setIsStudent, setUserInfo } from '../reduxToolkit/reduxIgong';

const AutoLogout = ({ timeout = 60 * 60 * 1000 }) => { // 기본 타임아웃 1분 (60,000ms)
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const timerRef = useRef(null);

  // 사용자 활동 감지 및 타이머 초기화
  const resetTimer = useCallback(() => {
    if (timerRef.current) clearTimeout(timerRef.current); // 기존 타이머 초기화
    timerRef.current = setTimeout(() => {
      handleLogout(); // 타임아웃 시 로그아웃
    }, timeout);
  }, [timeout]);

  // 로그아웃 및 페이지 이동
  const handleLogout = () => {
    fnc.setCookie('token','', 1);//이건 사용 안해
    dispatch(setIsLoggedIn(false));
    dispatch(setIsAdmin(false));

    alert('로그아웃되었습니다. 다시 로그인해주세요.');
    navigate('/'); // 로그인 페이지로 이동
  };

  // 이벤트 리스너 등록
  useEffect(() => {
    const events = ['mousemove', 'mousedown', 'keypress', 'scroll', 'touchstart'];
    events.forEach((event) => window.addEventListener(event, resetTimer));
    resetTimer(); // 컴포넌트 초기화 시 타이머 설정

    return () => {
      events.forEach((event) => window.removeEventListener(event, resetTimer)); // 이벤트 리스너 해제
      if (timerRef.current) clearTimeout(timerRef.current); // 타이머 제거
    };
  }, [resetTimer]);

  return null; // UI 없이 동작만 수행
};

export default AutoLogout;
